import { CircularProgress, Paper, PaperProps } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import {
  useAdminClaimDataEntriesQuery,
  useAdminClaimScheduledActionsQuery,
  useClaimDataEntriesQuery,
  useClaimScheduledActionsQuery,
} from '../../../api/gql';
import { DataEntry } from '../../../components/DataEntry';
import { useClaimDataOverview } from './data-overview/useClaimDataOverview';

type Props = {
  id: string;
  transNS?: string;
};

function ClaimDataOverviewComponent(props: { entries: { [p: string]: string | number } | null }) {
  return (
    <Grid2 container spacing={4}>
      {props.entries
        ? Object.entries(props.entries).map(([key, value]) => (
            <Grid2 xs={12} md={6} key={key}>
              <DataEntry title={key} text={`${value}`} />
            </Grid2>
          ))
        : null}
    </Grid2>
  );
}

export const ClaimDataOverview = ({ id, transNS = 'page-claim-detail' }: Props) => {
  const { data, isLoading } = useClaimDataEntriesQuery({
    id,
  });
  const { data: scheduledActionsData, isLoading: isScheduledActionsLoading } = useClaimScheduledActionsQuery({ id });

  const { entries } = useClaimDataOverview({
    id,
    transNS,
    data: data?.invoice,
    scheduledActionsData: scheduledActionsData?.invoice.scheduledActions,
  });

  if (isScheduledActionsLoading || isLoading) {
    return <CircularProgress />;
  }

  return <ClaimDataOverviewComponent entries={entries} />;
};
export const AdminClaimDataOverview = ({ id, transNS = 'page-claim-detail' }: Props) => {
  const { data, isLoading } = useAdminClaimDataEntriesQuery({
    id,
  });
  const { data: scheduledActionsData, isLoading: isScheduledActionsLoading } = useAdminClaimScheduledActionsQuery({
    id,
  });
  const { entries } = useClaimDataOverview({
    id,
    transNS,
    data: data?.adminInvoice,
    scheduledActionsData: scheduledActionsData?.adminInvoice.scheduledActions,
  });

  if (isScheduledActionsLoading || isLoading) {
    return <CircularProgress />;
  }
  return <ClaimDataOverviewComponent entries={entries} />;
};
